var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSparkleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.227 5.33c.518-1.773 3.028-1.773 3.547 0l1.334 4.562 4.563 1.335c1.772.518 1.772 3.028 0 3.547l-4.563 1.334-1.335 4.563c-.518 1.772-3.028 1.772-3.546 0l-1.335-4.563-4.563-1.334c-1.772-.519-1.772-3.029 0-3.547l4.563-1.335zM5.694 3.228c.09-.305.522-.305.61 0l.51 1.74c.031.105.112.186.216.217l1.742.509c.304.089.304.52 0 .61l-1.742.51a.32.32 0 0 0-.215.215l-.51 1.742c-.09.304-.521.304-.61 0l-.51-1.742a.32.32 0 0 0-.215-.215l-1.741-.51c-.305-.09-.305-.521 0-.61l1.74-.51a.32.32 0 0 0 .217-.215z",
  clipRule: "evenodd"
})));
export default SvgGemSparkleFilled;